export const getters = {
  getLeagues: state => state.leagues,
  league: state => state.league,
  leaguesAttitude: state => state.leaguesRelations
};
